import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconStays: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 2C16.6 2 17 2.4 17 3V4H19C19.6 4 20 4.4 20 5V20H21C21.6 20 22 20.4 22 21C22 21.6 21.6 22 21 22H3C2.4 22 2 21.6 2 21C2 20.4 2.4 20 3 20H4V5C4 4.4 4.4 4 5 4H7V3C7 2.4 7.4 2 8 2H16ZM9 4V5C9 5.6 8.6 6 8 6H6V20H18V6H16C15.4 6 15 5.6 15 5V4H9ZM10 16C10.6 16 11 16.4 11 17C11 17.6 10.6 18 10 18H9C8.4 18 8 17.6 8 17C8 16.4 8.4 16 9 16H10ZM15 16C15.6 16 16 16.4 16 17C16 17.6 15.6 18 15 18H14C13.4 18 13 17.6 13 17C13 16.4 13.4 16 14 16H15ZM10 12C10.6 12 11 12.4 11 13C11 13.6 10.6 14 10 14H9C8.4 14 8 13.6 8 13C8 12.4 8.4 12 9 12H10ZM15 12C15.6 12 16 12.4 16 13C16 13.6 15.6 14 15 14H14C13.4 14 13 13.6 13 13C13 12.4 13.4 12 14 12H15ZM10 8C10.6 8 11 8.4 11 9C11 9.6 10.6 10 10 10H9C8.4 10 8 9.6 8 9C8 8.4 8.4 8 9 8H10ZM15 8C15.6 8 16 8.4 16 9C16 9.6 15.6 10 15 10H14C13.4 10 13 9.6 13 9C13 8.4 13.4 8 14 8H15Z',
    })
  )
}
